import { useLanguage } from '../context/LanguageContext';
import { getTranslation } from '../translations/translations';

const ModulesSection = () => {
  const { language } = useLanguage();
  const modules = [
    {
      id: "admission",
      titleKey: "modulesSection.admissionTitle",
      icon: "bi-person-plus",
      featuresKey: "modulesSection.admissionFeatures"
    },
    {
      id: "academics",
      titleKey: "modulesSection.academicsTitle",
      icon: "bi-book",
      featuresKey: "modulesSection.academicsFeatures"
    },
    {
      id: "exams",
      titleKey: "modulesSection.examsTitle",
      icon: "bi-file-earmark-check",
      featuresKey: "modulesSection.examsFeatures"
    },
    {
      id: "finance",
      titleKey: "modulesSection.financeTitle",
      icon: "bi-cash-coin",
      featuresKey: "modulesSection.financeFeatures"
    },
    {
      id: "hr",
      titleKey: "modulesSection.hrTitle",
      icon: "bi-people",
      featuresKey: "modulesSection.hrFeatures"
    },
    {
      id: "library",
      titleKey: "modulesSection.libraryTitle",
      icon: "bi-journal-bookmark",
      featuresKey: "modulesSection.libraryFeatures"
    },
    {
      id: "inventory",
      titleKey: "modulesSection.inventoryTitle",
      icon: "bi-box-seam",
      featuresKey: "modulesSection.inventoryFeatures"
    },
    {
      id: "communication",
      titleKey: "modulesSection.communicationTitle",
      icon: "bi-chat-dots",
      featuresKey: "modulesSection.communicationFeatures"
    },
    {
      id: "mobile",
      titleKey: "modulesSection.mobileTitle",
      icon: "bi-phone",
      featuresKey: "modulesSection.mobileFeatures"
    },
    {
      id: "budget",
      titleKey: "modulesSection.budgetTitle",
      icon: "bi-graph-up",
      featuresKey: "modulesSection.budgetFeatures"
    },
    {
      id: "donation",
      titleKey: "modulesSection.donationTitle",
      icon: "bi-hand-thumbs-up",
      featuresKey: "modulesSection.donationFeatures"
    },
    {
      id: "certificates",
      titleKey: "modulesSection.certificatesTitle",
      icon: "bi-file-earmark-pdf",
      featuresKey: "modulesSection.certificatesFeatures"
    },
    {
      id: "idcard",
      titleKey: "modulesSection.idcardTitle",
      icon: "bi-credit-card",
      featuresKey: "modulesSection.idcardFeatures"
    },
    {
      id: "meal",
      titleKey: "modulesSection.mealTitle",
      icon: "bi-cup-hot",
      featuresKey: "modulesSection.mealFeatures"
    },
    {
      id: "scholarship",
      titleKey: "modulesSection.scholarshipTitle",
      icon: "bi-mortarboard",
      featuresKey: "modulesSection.scholarshipFeatures"
    }
  ];

  return (
    <section className="section-padding modules-section" id="modules">
      <svg className="modules-bg left" width="250" height="250" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="blueGradientLeft" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#94d6ff" stopOpacity="0.8" />
            <stop offset="100%" stopColor="#157ff6" stopOpacity="0.8" />
          </linearGradient>
        </defs>
        <path d="M100,30 Q140,10 180,40 Q200,80 180,120 Q160,160 120,180 Q80,200 40,180 Q0,160 10,120 Q20,80 40,40 Q60,10 100,30 Z" fill="url(#blueGradientLeft)" />
      </svg>
      <svg className="modules-bg right" width="250" height="250" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="blueGradientRight" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#94d6ff" stopOpacity="0.8" />
            <stop offset="100%" stopColor="#157ff6" stopOpacity="0.8" />
          </linearGradient>
        </defs>
        <path d="M100,30 Q140,10 180,40 Q200,80 180,120 Q160,160 120,180 Q80,200 40,180 Q0,160 10,120 Q20,80 40,40 Q60,10 100,30 Z" fill="url(#blueGradientRight)" />
      </svg>
      <div className="container">
        <div className="section-title" data-aos="fade-up">
          <h2>{getTranslation(language, 'modulesSection.title')}</h2>
          <p>
            {getTranslation(language, 'modulesSection.subtitle')}
          </p>
        </div>
        
        <div className="row">
          <div className="col-lg-10 mx-auto">
            <div className="accordion accordion-custom" id="modulesAccordion" data-aos="fade-up">
              {modules.map((module, index) => {
                const features = getTranslation(language, module.featuresKey);
                return (
                  <div className="accordion-item" key={module.id}>
                    <h2 className="accordion-header" id={`heading-${module.id}`}>
                      <button 
                        className={`accordion-button ${index !== 0 ? 'collapsed' : ''}`}
                        type="button" 
                        data-bs-toggle="collapse" 
                        data-bs-target={`#collapse-${module.id}`}
                        aria-expanded={index === 0 ? 'true' : 'false'}
                        aria-controls={`collapse-${module.id}`}
                      >
                        <i className={`bi ${module.icon} me-3`}></i>
                        {getTranslation(language, module.titleKey)}
                      </button>
                    </h2>
                    <div 
                      id={`collapse-${module.id}`}
                      className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                      aria-labelledby={`heading-${module.id}`}
                      data-bs-parent="#modulesAccordion"
                    >
                      <div className="accordion-body">
                        <div className="row">
                          {Array.isArray(features) && features.map((feature, idx) => (
                            <div key={idx} className="col-md-6">
                              <ul className="mb-0">
                                <li>{feature}</li>
                              </ul>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ModulesSection;
